// 用户权限设置
<template>
  <el-scrollbar wrap-class="scrollbar-wrapper-y">
    <div>
      <div class="flex">
        <span>绿疏名称:</span>
        <el-input
          v-model="name"
          size="mini"
          @keyup.enter.native="
            currentPage = 1;
            flush();
          "
          placeholder="请输入绿疏名称"
        />
        <div class="flex1"></div>

        <el-button class="add-btn" size="mini" icon="el-icon-circle-plus" @click="edit(0)"
          >新增</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="items"
        tooltip-effect="dark"
        border
        row-key="id"
        align="center"
        :stripe="true"
        size="medium"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column width="80" align="center" label="序号">
          <template slot-scope="scope">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="vegetableTypeName"
          label="一级绿疏类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="vegetableSecondTypeName"
          label="二级绿疏名称"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="addUser"
          label="创建人"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="addTime"
          label="创建时间"
          align="center"
          width="200"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
              <el-button
                class="edit-btn"
                size="mini"
                @click="edit(1, scope.row)"
                icon="el-icon-edit"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="top-start">
              <el-button
                class="remove-btn"
                size="mini"
                @click="remove(1, scope.row)"
                icon="el-icon-delete"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page_footer_box"
        @size-change="
          currentPage = 1;
          flush();
        "
        @current-change="flush"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100, 300]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <EditDialog :config="config" @close="flush"></EditDialog>
  </el-scrollbar>
</template>

<script>
import { Message } from "element-ui";
import EditDialog from "../../../components/dialog/base/VegetableSecondTypeEdit.vue";
export default {
  components: {
    EditDialog,
  },
  data() {
    return {
      items: [],
      name: "",
      show: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      config: {
        show: false,
        width: 500,
        title: "",
        type: 0, //0 创建，1 修改名称
        data: {},
      },
      imgconfig: {
        show: false,
        width: 500,
        title: "",
        type: 0, //0 创建，1 修改名称
        data: {},
        URL: "",
      },
    };
  },
  filters: {},
  mounted() {
    this.flush();
  },
  methods: {
    async flush() {
      let result = await this.$http.post("/api/VegetableSecondType/Search", {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        name: this.name,
      });
      this.items = result.list;
      this.total = result.totalCount;
    },
    handleSelectionChange(val) {
      this.selectitems = val;
    },
    roleCheck(row) {},
    // 资源编辑
    edit(type, row) {
      this.config.type = type;
      switch (type) {
        case 0:
          this.config.title = "新增";
          this.config.data = {};
          this.config.show = true;
          break;
        case 1:
          this.config.title = "编辑";
          this.config.data = Object.assign({}, row);
          this.config.show = true;
          break;
      }
    },
    // 资源编辑
    async remove(type, row) {
      await this.$confirm("确认删除该数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      row.disabled = 1;
      let data = Object.assign({}, row);
      data.disabled = 1;
      let result = await this.$http.post("/api/VegetableSecondType/Update", data);
      this.$message({
        type: "success",
        message: "删除成功！",
      });
      this.flush();
    },
  },
};
</script>

<style lang="scss" scoped>
.page_footer_box {
  float: right;
  margin: 3px 10px;
}
</style>
